import { useDeployMai } from '@sunstone/api-client/hooks';
import {
  AlertDialog,
  AlertDialogAction,
  AlertDialogCancel,
  AlertDialogContent,
  AlertDialogDescription,
  AlertDialogFooter,
  AlertDialogHeader,
  AlertDialogTitle,
} from '@sunstone/ui';
import { toast } from 'sonner';
import { useAuthToken } from '@/features/auth';

interface DeployMaiDialogProps {
  workspaceId: string;
  open: boolean;
  onOpenChange: (open: boolean) => void;
}

export function DeployMaiDialog({ workspaceId, open, onOpenChange }: DeployMaiDialogProps) {
  const { token } = useAuthToken();
  const deployMai = useDeployMai(token);

  function handleDeploy() {
    deployMai.mutate(
      { workspaceId, installerBranch: '' },
      {
        onSuccess: () => {
          toast.success('MAI deploy dispatched.');
        },
        onError: (err) => toast.error(err.message ?? 'Failed to dispatch MAI deploy.'),
      },
    );
  }

  return (
    <AlertDialog open={open} onOpenChange={onOpenChange}>
      <AlertDialogContent>
        <AlertDialogHeader>
          <AlertDialogTitle>Deploy MAI</AlertDialogTitle>
          <AlertDialogDescription>
            Deploy the MAI components to this workspace using the current release's installer
            branch.
          </AlertDialogDescription>
        </AlertDialogHeader>
        <AlertDialogFooter>
          <AlertDialogCancel>Cancel</AlertDialogCancel>
          <AlertDialogAction onClick={handleDeploy}>Deploy</AlertDialogAction>
        </AlertDialogFooter>
      </AlertDialogContent>
    </AlertDialog>
  );
}
